import { post } from './API';

/**
 * Flight lookup and validation service
 */
const FlightService = {
  /**
   * Look up flight information and validate against booking details
   * @param {string} flightNumber - The flight number to look up
   * @param {string} pickupAddress - The pickup address to validate against
   * @param {string} dropoffAddress - The dropoff address to validate against
   * @param {string} pickupDate - The pickup date/time to compare
   * @returns {Promise<object>} Flight validation result
   */
  async lookupFlight(flightNumber, pickupAddress = '', dropoffAddress = '', pickupDate = '') {
    const response = await post('bookings/flight-lookup', {
      flightNumber,
      pickupAddress,
      dropoffAddress,
      pickupDate,
    });

    return response?.data?.data;
  },
};

export default FlightService;
